// ----------------------------------------------------------------------
// <copyright file="Izenda.ResetPasswordWrapperActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

! function () {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var AccountStore = require('logic/Izenda.AccountStore');
  var AccountConstants = require('logic/data/Izenda.AccountConstants');

  var resetPasswordWrapperActions = compose(
    withHandlers({
      initStore: initStore,
      updateUserId: updateUserId
    }));

  /**
   * Initial store.
   */
  function initStore() {
    return function (component) {
      component.store = new AccountStore(AccountConstants.MODES.RESET_PASSWORD);
    };
  }

  /**
   * Update user's id.
   */
  function updateUserId() {
    return function (component) {
      var props = component.props;
      var id = props.params.id;

      component.store.model.updateProperty('id', id);
    };
  }

  module.exports = resetPasswordWrapperActions;
}();


// WEBPACK FOOTER //
// ./ui/modules/Account/Izenda.ResetPasswordWrapperActions.js